<template>
  <div v-if="activePoll">
    <div v-if="!loading">
      <div v-if="noResults">
        No results yet
      </div>
      <div
        class="pb-3"
        v-for="(item, index) in activePoll.answers"
        v-bind:key="index"
      >
        <div
          :style="{
            fontWeight: boldSelectedAnswers(index) ? '600' : '',
            margin: '0 0 0 3px',
            width: '70%',
            float: 'left'
          }"
        >
          {{ item.title }}
        </div>
        <div style="text-align:right; width:20%; float: right;">
          <span v-if="manager || user.scrutineer">({{ item.count }})</span>
          {{ countToPercent(item.count) }}%
        </div>
        <v-progress-linear
          rounded
          :value="countToPercent(item.count)"
          height="7"
        >
        </v-progress-linear>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["poll", "voteResponse"],
  data: () => ({
    loading: false,
    noResults: false
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      manager: (state) => state.manager,
      activePoll: (state) => state.polls.activePoll
    })
  },
  methods: {
    boldSelectedAnswers(index) {
      if (Array.isArray(this.voteResponse)) {
        return this.voteResponse.includes(this.activePoll.answers[index]._id);
      } else return this.voteResponse === this.activePoll.answers[index]._id;
    },
    countToPercent(score) {
      if (score === 0) return 0;
      return Math.round((score / this.activePoll.totalVotes) * 100);
    }
  }
};
</script>
